module.exports = __webpack_public_path__ + "img/icon_kehu_04.f1c2a75d.png";